<template>
  <div class="example">
    <h2 class="mb-20">loading...</h2>
    <a-spin />
  </div>
</template>

<style scoped>
@import "../assets/global.scss";
.example {
  text-align: center;
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 100px 0;
}
</style>
